import React from 'react'
import { useSelector } from 'react-redux';
import './player-quest-item.styles.scss';
import { stripHtml } from '@/utils/sanitize';
import ImageContainer from '@/components/SHARED/image-container/image-container.component';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock } from '@fortawesome/free-solid-svg-icons';

const PlayerQuestItem = ({
  quest,
  onClick,
}) => {

  const screenSize = useSelector(state => state.contentData.screenSize);
  const isLocked = quest.questStatus === 'locked';
  // Locked quests are only viewable when the creator has enabled a preview.
  const canView = !isLocked || quest.opt_preview;
  // Hide the real icon for locked quests that have no preview.
  const showMystery = isLocked && !quest.opt_preview;

  const mysteryQuest = '/images/icons/mystery-quest.png';

  return (
    <div className={`player-quest-item-wrapper ${screenSize}`}>
      <div
        className={`player-quest-item g-list-item with-shadow${canView ? ' clickable' : ''}${quest.questStatus === 'inProgress' ? ' in-progress' : ''}`}
        onClick={canView ? onClick : undefined}
      >
        <div className='quest-icon-wrapper'>
          <ImageContainer
            src={showMystery ? mysteryQuest : (quest.icon || '/images/icons/quests.png')}
            alt={showMystery ? 'mystery quest icon' : `${quest.name} quest icon`}
            className='quest-icon'
          />
          {quest.questStatus === 'complete' && (
            <ImageContainer
              src='/images/icons/completed-overlay-green.png'
              alt='completed overlay'
              className='quest-completed-overlay'
            />
          )}
        </div>
        <div>
          <div className='quest-name'>
            {(!showMystery && quest.name) 
              ? quest.name
              : 'Mystery Quest'}
            {quest.questStatus === 'inProgress' && (
              <div className='quest-in-progress-badge'>In Progress</div>
            )}
          </div>
          <div className="g-space-0-5"></div>
          <div className='quest-desc'>
            {
              (!showMystery &&
              quest.desc) && 
              stripHtml(quest.desc).substring(0, screenSize === 'mobile' ? 60 : 150)
            }
            {
              (!showMystery &&
              quest.desc) && 
              stripHtml(quest.desc).length > (screenSize === 'mobile' ? 60 : 150)
                ? '...'
                : ''
            }
          </div>
          <div className="g-space-0-5"></div>
          <div className='checkpoint-count'>
            Checkpoints: {quest.checkpoints?.length || 0}
          </div>
          {
            isLocked && quest.missingReqs && quest.missingReqs.length > 0 && (
              <div className='quest-locked-reqs'>
                <div className="g-space-0-5"></div>
                <div className='quest-locked-reqs-title'>
                  <FontAwesomeIcon icon={faLock} /> To unlock:
                </div>
                <ul>
                  {
                    quest.missingReqs.map(req => (
                      <li key={req.id} className={req.class || ''}>{req.text}</li>
                    ))
                  }
                </ul>
              </div>
            )
          }
        </div>
      </div>
    </div>
  )
}

export default PlayerQuestItem
